import { useCallback, useEffect, useState } from 'react';
import { fetchMyAppUserRow } from '../api/profileApi';
import { useMingo } from '../context/MingoContext';
import { getVisaHeaderBadge, resolveVisaExpiryYmd } from '../lib/visaHeaderBadge';

/**
 * Loads logged-in user's visa_expiry_date for the main header badge.
 * @returns {{ kind: 'urgent'|'warn', text: string }|null}
 */
export function useVisaHeaderBadge() {
  const { t, isGuest, isLoggedIn } = useMingo();
  const [badge, setBadge] = useState(null);

  const refresh = useCallback(async () => {
    if (isGuest || !isLoggedIn) {
      setBadge(null);
      return;
    }
    try {
      const me = await fetchMyAppUserRow();
      const ymd = resolveVisaExpiryYmd(me);
      setBadge(getVisaHeaderBadge(ymd, t));
    } catch {
      setBadge(null);
    }
  }, [isGuest, isLoggedIn, t]);

  useEffect(() => {
    void refresh();
    const onVisaUpdated = () => {
      void refresh();
    };
    window.addEventListener('mingo-visa-updated', onVisaUpdated);
    return () => window.removeEventListener('mingo-visa-updated', onVisaUpdated);
  }, [refresh]);

  return badge;
}
